import { Css, useTestIds } from "@homebound/beam";
import { Link } from "react-router-dom";
import { HomeboundLogo } from "src/components";
import { Pdf_TradePartnerContactFragment } from "src/routes/pdfs/BillPdf/BillPdf.generated";
import { getCompanyInfoField } from "../CommitmentOrChangeOrderPdf/utils/companyInfoUtils";
import { CompanyInfoFieldFragment } from "../CommitmentOrChangeOrderPdf/utils/companyInfoUtils.generated";
type PdfFooterProps = {
  tradeContact: Pdf_TradePartnerContactFragment | undefined | null;
  project: CompanyInfoFieldFragment;
};
export function PdfFooter({ tradeContact, project }: PdfFooterProps) {
  const tid = useTestIds({}, "footer");
  return (
    <div css={Css.bt.mt8.bcGray300.bw1.$}>
      <div css={Css.dg.gtc("200px 240px 200px").xs.gap4.mt5.$}>
        <div css={Css.mt3.$} {...tid.logo}>
          <HomeboundLogo width={100} height={31} />
        </div>

        <div css={Css.df.fdc.jcfs.aifs.$} {...tid.hbAccountingInfo}>
          <div css={Css.gray600.mb1.$}>Pay from</div>
          <div>{getCompanyInfoField(project, "name")}</div>
          <div>1875 Mission St. Ste 103, #257</div>
          <div>San Francisco, CA 94103</div>
          <div>{getCompanyInfoField(project, "phoneNumber")}</div>
          <Link
            to={`mailto:${getCompanyInfoField(project, "email")}`}
            css={Css.xs.addIn("&:hover", Css.textDecoration("none").bb.bcWhite.pb2.$).$}
          >
            {getCompanyInfoField(project, "email")}
          </Link>
        </div>

        {tradeContact && (
          <div css={Css.df.fdc.jcfs.aifs.$} {...tid.tradeSignatoryInfo}>
            <div css={Css.gray600.mb1.$}>Pay to</div>
            <div>{tradeContact.tradePartner.name}</div>
            <div>{tradeContact.officePhone}</div>
            <Link
              to={`mailto:${tradeContact?.email}`}
              css={Css.xs.addIn("&:hover", Css.textDecoration("none").bb.bcWhite.pb2.$).$}
            >
              {tradeContact.email}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
